module.exports = __webpack_public_path__ + "static/img/14000122.128a510a.png";